import { render, staticRenderFns } from "./ChatInitial.vue?vue&type=template&id=9016fee2&"
import script from "./ChatInitial.vue?vue&type=script&lang=js&"
export * from "./ChatInitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports